import { h } from "preact";

export default function MiniCartItemFinalSaleBadge({ item, className }) {
  const finalSale = item.properties?._final_sale === "true";
  if (!finalSale) return null;

  return (
    <div
      className={className}
      style={{ "--badge-color": "var(--color-sale-red)" }}
    >
      {window.localeStrings.product.final_sale}
    </div>
  );
}
